// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"44f12a94","528":"37985f7f","572":"58ef9ec8","592":"5c512b11"}[chunkId] + ".chunk.js";
};